<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">{{ letter.buyProduct }}</template>
    <template slot="select-content">
      <ul class="area-select-container j-product-select-container">
        <li
          class="areas-lst select-items-popup j-product-dcount"
          :class="{ active: curProduct.PRODUCT_ID === product.PRODUCT_ID }"
          @click="selectProduct(product)"
          v-for="product in productList"
          :key="product.PRODUCT_ID"
        >
          {{ getProductName(product) }}
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialTopup/selectContainer';
import { getProductList } from '@store/officialTopup/storager';
import product from '@mixins/product';
export default {
  mixins: [selectContainer, product],
  data() {
    let productList = getProductList();
    return {
      productList
    };
  },
  props: ['curProduct'],
  methods: {
    selectProduct(product) {
      this.$emit('select-product', product);
      this.close();
    }
  }
};
</script>
